import { render, staticRenderFns } from "./AboutRecruitmentPage.vue?vue&type=template&id=0a26267a&scoped=true"
import script from "./AboutRecruitmentPage.vue?vue&type=script&lang=js"
export * from "./AboutRecruitmentPage.vue?vue&type=script&lang=js"
import style0 from "./AboutRecruitmentPage.vue?vue&type=style&index=0&id=0a26267a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a26267a",
  null
  
)

export default component.exports